/* eslint-disable radix */
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaTimesCircle,
} from 'react-icons/fa';
import ReactAudioPlayer from 'react-audio-player';
import Spacer from '../../../../components/spacer';
import { getRecordingMetas, getMyAccount } from '../../../../api/queries';
import MP3 from '../../../../components/mp3';
import ButtonPrimary from '../../../../components/buttonPrimary';
import RecordingAttachmentForm from './RecordingAttachmentForm';
import AppState from '../../../../store/appstate';
import { hasAdminRights } from '../../../../auth/shared';

function SongRecording({ recording, last }) {
  const recordingMetas = getRecordingMetas({ id: recording.workcode });

  const [recordingAttachmentModal, setRecordingAttachmentModal] = useState(null);
  const [recordingMp3Modal, setrecordingMp3Modal] = useState(null);
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const adminRights = hasAdminRights(myAccount?.data);
  const { t } = useTranslation('songs');

  let recordingInfo = null;

  if (recordingMetas.isSuccess) {
    recordingInfo = recordingMetas?.data?.find(
      (r) => (r.id === recording.recordingidentifier || r.id === recording.uicbarcode),
    );
  }

  const attachMp3lbl = recording.s3presignedurl ? t('songs:attach-new-mp3') : t('songs:attach-mp3');

  useEffect(() => {
    setTimeout(() => {
      recordingMetas.refetch();
    }, 1000);
  }, []);

  return (
    <div className={`flex flex-wrap items-center py-2  ${last ? '' : 'border-b border-sentric-menu-gray'} `}>
      {recordingAttachmentModal !== null && (
        <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white relative w-11/12 lg:w-auto">
            <button
              type="button"
              onClick={() => setRecordingAttachmentModal(null)}
              className="absolute z-50 right-0 top-0 p-5 text-2xl"
            >
              <FaTimesCircle />
            </button>
            <div className="p-4 lg:p-8">
              <RecordingAttachmentForm artistaccountcode={recording.artistaccountcode} recordingamendmentidentifier={recording.recordingamendmentidentifier} recordingidentifier={recording.recordingidentifier} workcode={recording.workcode} modal closeModal={() => setRecordingAttachmentModal(null)} />
            </div>
          </div>
        </div>
      )}
      {recordingMp3Modal !== null && (
        <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white relative w-11/12 lg:w-auto">
            <button
              type="button"
              onClick={() => setrecordingMp3Modal(null)}
              className="absolute z-50 right-0 top-0 p-5 text-2xl"
            >
              <FaTimesCircle />
            </button>
            <div className="p-4 lg:p-12">
              <Spacer thin />
              <ReactAudioPlayer
                src={recording.s3presignedurl}
                controls
                title
              />
            </div>
          </div>
        </div>
      )}
      {(recordingInfo?.spotify_id || recordingInfo?.mp3)
      && (
      <div className="mr-4 lg:w-20 w-full lg:mb-0 mb-2 h-20">
          {recordingInfo?.spotify_id
          && (
            <iframe
              title="preview"
              src={`https://open.spotify.com/embed/track/${
                recordingInfo.spotify_id
              }`}
              width="80"
              height="80"
              frameBorder="0"
              allowtransparency="true"
              allow="encrypted-media"
              scrolling="no"
              style={{ borderRadius: '15px' }}
            />
          )}
        {!recordingInfo?.spotify_id && recordingInfo?.mp3
        && (
        <div style={{ width: '80px', height: '80px' }} className="flex flex-col items-center justify-center">
          <MP3 url={recordingInfo.mp3} />
          <p className="text-xs mt-1">MP3</p>
        </div>
        )}
      </div>
      )}
      <div>
        <h2 className="text-base font-semibold text-sentric-table-text">
          {' '}
          {recording.title}
          {' - '}
          {recording.ident}
          {' - '}
          {recording.performingartist}
        </h2>
        <p className="text-xs">
          ISRC:
          {' '}
          {recording.isrc || '-'}
          <span className="ml-2 mr-2">|</span>
          {t('songs:release-date')}
          :
          {' '}
          {recording.releasedate
            ? format(Date.parse(recording.releasedate), 'yyyy/MM/dd')
            : ''}
          <span className="ml-2 mr-2">|</span>
          {t('songs:record-label-caps')}
          :
          {' '}
          {recording.recordlabel || '-'}
        </p>
      </div>
      <div className="w-full flex flex-row lg:justify-end items-center">
        <ButtonPrimary
          onClick={() => setRecordingAttachmentModal({ recordingidentifier: recording.recordingidentifier, recordingamendmentidentifier: recording.recordingamendmentidentifier, workcode: recording.workcode })}
          disabled={!adminRights}
        >
          {attachMp3lbl}
        </ButtonPrimary>
        <span className="mr-2" />
        {recording?.s3presignedurl
          && (
          <ButtonPrimary
            onClick={() => setrecordingMp3Modal({ s3presignedurl: recording.s3presignedurl })}
            disabled={!adminRights}
          >
            {t('songs:play-mp3')}
          </ButtonPrimary>
          )}
      </div>
    </div>
  );
}

export default SongRecording;
